import React, {Component} from 'react';
import moment from "moment/moment";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import NavBarKS from "../../components/NavBarKS";
import StickButton from "../../components/StickButton";
import Table from "../../components/Table/Table";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import SurveyModal from "./SurveyModal";
import Alert from "react-s-alert";

class SurveyList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: [],
            loading: false,
            manual: false,
            page: 0,
            size: 10,
            total: 0,
            confirmDeleteModal: false,
            searching: false,
            searchQuery: undefined,
            recordId: null,
            surveyModal: false,
            mode: 'create'
        }
        this.fetchData = this.fetchData.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.getDistributors = this.getDistributors.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {
        this.getDistributors();
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=createdAt,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: '/survey/fetchAllSurvey?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "post",
        };
        self.setState({loading: true, manual: self.state.manual === true ? false : self.state.manual});
        self.props.reload(true);
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.length,
                    content: response.data,
                    loading: false,
                    searching: false,
                    selectedAll: false,
                    selection: [],
                    surveyModal: false,

                });
                self.props.reload(false);
            }).catch(function (error) {
            self.setState({loading: false});
            self.props.reload(false);
            showAxiosError(error);
        });
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    getDistributors() {
        let self = this;
        let params = {
            url: `/progresspayment/getDistributors`,
            method: "post"
        };
        request(params)
            .then(function (response) {
                let {distributors, allDistributors} = response.data;
                let distributorMap = allDistributors.reduce(function (map, obj) {
                    map[obj.recordId] = obj.customerName;
                    return map;
                }, {});

                distributors = distributors.map(distributor => ({
                    value: distributor.recordId,
                    label: distributor.customerName,
                    parentId: distributor.parentCustomerId
                }));

                allDistributors = allDistributors.map(distributor => ({
                    value: distributor.recordId,
                    label: distributor.customerName,
                    parentId: distributor.parentCustomerId
                }));
                distributors.unshift({value: null, label: 'Tümü'});
                self.setState({distributors, distributorMap, allDistributors});
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleDelete(item) {
        this.setState({confirmDeleteModal: true, recordId: item})
    }

    confirmDelete() {
        let self = this;
        let recordId = self.state.recordId;
        let params = {
            url: `/announcement/deleteAnnouncement`,
            method: 'post',
            data: recordId
        };
        request(params)
            .then(function (response) {
                self.setState({confirmDeleteModal: false, recordId: null, manual: self.state.manual === true ? false : self.state.manual});
                Alert.success("Silme işlemi başarıyla gerçekleştirildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.fetchData(self.state.accessor, self.state.direction, self.state.page, self.state.size)
            }).catch(function (error) {
            self.setState({confirmDeleteModal: false, recordId: null});
            showAxiosError(error);
        });
    }

    toggleModal(surveyModal, manual) {
        this.setState({surveyModal, manual});
    }

    render() {
        const announcementType =[{value:null,label:"Tümü"},{value:"MODAL",label:"MODAL"},{value:"CARD",label:"CARD"}];

        const fields = [
            {
                label: "Anket Adı",
                accessor: "content",
                type: "text",
                operator: "="
            },
            {
                label: `Başlangıç Tarihi`,
                accessor: "startDate",
                type: "datetime",
                operator: "=",
                disableAccessibleDate: true
            },
            {
                label: `Bitiş Tarihi`,
                accessor: "endDate",
                type: "datetime",
                operator: "=",
                disableAccessibleDate: true
            },
            {
                label: "Oluşturulma Tarihi (Başlangıç)",
                accessor: "min_createdAt",
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Oluşturulma Tarihi (Bitiş)",
                accessor: "max_createdAt",
                type: "datetime",
                operator: "<=",
            }
        ];

        const columns = [
            {
                Header: "#",
                accessor: "recordId",
                sortable: false,
                Cell: (row, index) => (<div style={{margin: 0}}>{index + 1}</div>)
            },
            {
                Header: "Anket Adı",
                accessor: "title",
                Cell: row => (<div>{row.title}</div>)
            },
            {
                Header: "Başlangıç Tarihi",
                accessor: "startTime",
                Cell: row => (
                    <div>{moment(row.startDate).isValid() ? moment(row.startDate).format("DD-MM-YYYY") : ''}</div>)
            },
            {
                Header: "Bitiş Tarihi",
                accessor: "endDate",
                Cell: row => (
                    <div>{moment(row.endDate).isValid() ? moment(row.endDate).format("DD-MM-YYYY") : ''}</div>)
            },
            {
                Header: "Oluşturma Tarihi",
                accessor: "createdAt",
                Cell: row => (
                    <div>{moment(row.createdAt).isValid() ? moment(row.createdAt).format("DD-MM-YYYY") : ''}</div>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: (item, index) => (
                    <div className="btn-group">

                        <div className="dropdown">
                            <button className="MenuBtn2 listt btn btn-default" type="button"
                                    data-toggle="dropdown">Seçİnİz
                            </button>
                            <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + item.recordId}>
                                <a className="dropdown-item" onClick={() => this.setState({
                                    mode: "update",
                                    recordId: item.recordId,
                                    surveyModal: true
                                })}>
                                    <i className="fa fa-edit"/> Düzenle
                                </a>

                                <a className="dropdown-item" onClick={() => this.handleDelete(item.recordId)}>
                                    <i className="fa fa-trash-alt"/> Sil
                                </a>
                            </div>
                        </div>
                    </div>
                )
            }
        ];
        return (
            <div className="row baseBackground">

                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
                    <StickButton className='stickButton plus-circle' position="leftSide"
                                 onClick={() => this.setState({mode: "create", surveyModal: true})}
                                 label="Yeni Oluştur"
                                 title="Yeni Oluştur"/>
                </NavBarKS>

                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Anket Listesi</h4>
                    </div>
                </div>
                <div className="card-body">
                    <div className=" ">
                        <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                            <DetailedSearch fields={fields}
                                            loading={this.state.searching}
                                            onSearch={this.handleSearch}/>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <Table columns={columns}
                           loading={this.state.loading}
                           loadingText="Kayıtlar getiriliyor..."
                           content={this.state.content}
                           total={this.state.total}
                           page={this.state.page}
                           manual={this.state.manual}
                           size={this.state.size}
                           options={["5", "10", "20", "50", "100"]}
                           fetchData={this.fetchData}
                    />
                </div>

                {this.state.surveyModal &&
                    <SurveyModal
                        mode={this.state.mode}
                        modal={this.state.surveyModal}
                        listener={(surveyModal, manual) => this.setState({
                            surveyModal,
                            manual,
                            recordId: null
                        })}
                        recordId={this.state.recordId}
                        allDistributors={this.state.allDistributors}
                        toggleModal={this.toggleModal}
                    />
                }
                <Modal isOpen={this.state.confirmDeleteModal}>
                    <ModalHeader/>
                    <ModalBody>
                        Silmek istediğinizden emin misiniz ?
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-sm-12 row">
                            <div className="col-sm-2">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn vazgec "
                                        onClick={() => this.setState({
                                            confirmDeleteModal: false
                                        })}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-sm-8"/>

                            <div className="col-sm-2">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn kaydet"
                                        onClick={() => this.confirmDelete()}>
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}

export default SurveyList;